import { render, staticRenderFns } from "./End.vue?vue&type=template&id=15278b2c&scoped=true"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"
import style0 from "./End.vue?vue&type=style&index=0&id=15278b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15278b2c",
  null
  
)

export default component.exports